import {PlaceFinder} from '../common/place-finder';
import {PlacedBin} from '../placed-bin';

export class OverlappingPlaceFinder extends PlaceFinder {

    private dx: number = 30;
    private dy: number = 30;

    public override produceVariants(): PlacedBin[] {
        return this.placedBins.reduce((placements: PlacedBin[], envBin) => {
            const x: number = envBin.x + this.dx;
            const y: number = envBin.y + this.dy;

            if (!this.isPosOccupied(x, y)) {
                const placedBin: PlacedBin = new PlacedBin(this.bin, x, y);

                placements.push(placedBin);
            }

            return placements;
        }, [])
            .filter(placedBin => this.board.isPlacedBinInside(placedBin));
    }

    private isPosOccupiedByBin(x: number, y: number, placedBin: PlacedBin): boolean {
        const rectX: number = placedBin.x - Math.trunc(this.dx / 2);
        const rectY: number = placedBin.y - Math.trunc(this.dy / 2);

        return rectX <= x && x < rectX + this.dx &&
            rectY <= y && y < rectY + this.dy;
    }

    private isPosOccupied(x: number, y: number): boolean {
        return this.placedBins.some(envBin => this.isPosOccupiedByBin(x, y, envBin));
    }

}
